import React from 'react';
import { SectionCardTitle, Text } from '../../../components/textVariations';
import { Icon } from '../../../utilities/icomoon-css';

export const SessionExpired = () => {
  return (
    <>
      <div className="sessionTimeOutIcon">
        <Icon name="tfw-clock-cp"></Icon>
      </div>
      <div className="sessionMessage">
        <div className="pb-4">
          <SectionCardTitle>Your session has expired!</SectionCardTitle>
        </div>

        <Text className="pt-4 pb-4">
          {' '}
          If you want to continue session, please sign in again.
        </Text>
      </div>
    </>
  );
};
